<template>
  <div class="page-app" v-loading="loading">
    <menus :menu-list="menus" :fold="collapseMenu" :current-code="currentCode" @fold="collapseMenu = !collapseMenu">
      <template slot="bottom">
        <el-switch v-if="isSaler" v-model="onlyNewAdd" active-text="只看新推广" @change="doTest"></el-switch>
        <el-select v-else v-model="areaSelect" :clearable="true">
          <el-option v-for="a in areas" :key="a" :label="area" :value="a"></el-option>
        </el-select>
      </template>
    </menus>
    <div class="content-wraper">
      <div class="header-bar">
        <div id="menu-btn" @click="collapseMenu = !collapseMenu">
          <i :class="collapseMenu ? 'crm-icon-menu' : 'crm-icon-close'" />
        </div>
        <div class="title">
          兆配云CRM
        </div>
        <div class="actions">
          <!-- <el-button type="text" size="mini" @click="doExpMonth">销售导出</el-button> -->
          <el-switch v-if="isSaler" v-model="onlyNewAdd" active-text="只看新推广"></el-switch>
          <el-select
            v-else
            v-model="areaSelect"
            :clearable="true"
            size="small" style="width: 120px;" placeholder="区域查看"
            data-uac="common.areaselect$$通用设置.区域选择"
            v-uac="'common.areaselect'"
          >
            <el-option v-for="a in areas" :key="a" :label="a" :value="a"></el-option>
          </el-select>
        </div>
        <div class="profile" :class="{ 'show-pannel' : pannelShow }">
          <div class="profile-info" @click="handleTogglePannel">
            <div class="header" style="background-image:url('/images/icon.png')"></div>
            <div class="name">{{ auth.displayName }}</div>
          </div>
          <div class="ext-pannel">
            <div class="item">{{ auth.userName }}</div>
            <div class="item">{{ auth.role }}</div>
            <div class="item link" @click.stop="doModifyPwd">修改密码</div>
            <div class="item link" @click.stop="doLogout">退出登录</div>
          </div>
        </div>
      </div>
      <div class="page-view">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config'
import Menus from '@/components/Menus'
import Utils from '@/utils'
export default {
  name: 'AppMain',
  components: { Menus },
  data () {
    return {
      loading: false,
      onlyNewAdd: false,
      areaSelect: undefined,
      collapseMenu: true,
      pannelShow: false,
      menus: []
    }
  },
  computed: {
    areas () {
      return this.$store.state.stAreas || []
    },
    auth () {
      return this.$store.state.auth || {}
    },
    currentCode () {
      return (this.$route.meta && this.$route.meta.code) || 'm.home'
    },
    isSaler () {
      return ~['销售', '销售代理'].indexOf(this.auth.role)
    }
  },
  watch: {
    collapseMenu (val) {
      this.$nextTick(() => {
        if (document.body.clientWidth < 768) {
          if (!val) {
            Utils.EventBinder.bind(document, 'click', this.collapseMenuOutSide)
          } else {
            Utils.EventBinder.unbind(document, 'click', this.collapseMenuOutSide)
          }
        }
      })
    },
    pannelShow (val) {
      this.$nextTick(() => {
        if (val) {
          Utils.EventBinder.bind(document, 'click', this.hidePannelOutSide)
        } else {
          Utils.EventBinder.unbind(document, 'click', this.hidePannelOutSide)
        }
      })
    },
    currentCode (val) {
      if (document.body.clientWidth < 768) {
        this.collapseMenu = true
      }
    },
    onlyNewAdd (val) {
      this.$store.dispatch('UpdateNewAdd', val)
    },
    areaSelect (val) {
      this.$store.dispatch('SelectArea', val)
    }
  },
  async beforeMount () {
    const ctx = this
    this.menus = [
      {
        code: '_default',
        name: '工作台',
        uacConfig: 'data-uac="m.dashboard$$工作台"',
        clickHandler (ev) {
          if (ctx.$router.currentRoute.path !== '/dashboard' && ctx.$router.currentRoute.path !== '/') {
            ctx.$router.push('/')
          }
          ev.preventDefault()
        },
        icon: 'crm-icon-dashboard'
      },
      {
        code: 'm.home',
        name: '统计报表',
        uacConfig: 'data-uac="m.home$$统计报表"',
        clickHandler (ev) {
          if (ctx.$router.currentRoute.path !== '/home') {
            ctx.$router.push('/home')
          }
          ev.preventDefault()
        },
        icon: 'crm-icon-baobiao'
      }, {
        code: 'm.financeorder',
        name: '客户订单',
        uacConfig: 'data-uac="m.financeorder$$客户订单"',
        clickHandler (ev) {
          if (ctx.$router.currentRoute.path !== '/financeorder') {
            ctx.$router.push('/financeorder')
          }
          ev.preventDefault()
        },
        icon: 'crm-icon-sale'
      }, {
        code: 'm.financeaftersale',
        name: '订单售后',
        uacConfig: 'data-uac="m.financeaftersale$$订单售后"',
        clickHandler (ev) {
          if (ctx.$router.currentRoute.path !== '/financeaftersale') {
            ctx.$router.push('/financeaftersale')
          }
          ev.preventDefault()
        },
        icon: 'crm-icon-aftersale'
      }, {
        code: 'm.customer',
        name: '客户管理',
        uacConfig: 'data-uac="m.customer$$客户管理"',
        clickHandler (ev) {
          if (ctx.$router.currentRoute.path !== '/customer') {
            ctx.$router.push('/customer')
          }
          ev.preventDefault()
        },
        icon: 'crm-icon-customers'
      }, {
        code: 'm.order',
        name: '订单管理',
        uacConfig: 'data-uac="m.order$$订单管理"',
        icon: 'crm-icon-order',
        clickHandler (ev) {
          ev.preventDefault()
        },
        children: [
          {
            code: 'm.order.list',
            name: '订单列表',
            uacConfig: 'data-uac="m.order.list$$订单管理.订单列表"',
            clickHandler (ev) {
              if (ctx.$router.currentRoute.path !== '/order/list') {
                ctx.$router.push('/order/list')
              }
              ev.preventDefault()
              ev.stopPropagation()
            }
          },
          {
            code: 'm.order.refund',
            name: '售后列表',
            uacConfig: 'data-uac="m.order.refund$$订单管理.售后列表"',
            clickHandler (ev) {
              if (ctx.$router.currentRoute.path !== '/order/refund') {
                ctx.$router.push('/order/refund')
              }
              ev.preventDefault()
              ev.stopPropagation()
            }
          },
          {
            code: 'm.order.create',
            name: '订单审批',
            uacConfig: 'data-uac="m.order.create$$订单管理.订单审批"',
            clickHandler (ev) {
              if (ctx.$router.currentRoute.path !== '/order/create') {
                ctx.$router.push('/order/create')
              }
              ev.preventDefault()
              ev.stopPropagation()
            }
          },
          {
            code: 'm.order.package',
            name: '出库记录',
            uacConfig: 'data-uac="m.order.package$$订单管理.出库记录"',
            clickHandler (ev) {
              if (ctx.$router.currentRoute.path !== '/order/package') {
                ctx.$router.push('/order/package')
              }
              ev.preventDefault()
              ev.stopPropagation()
            }
          }
        ]
      }, {
        code: 'm.operate',
        name: '运营管理',
        uacConfig: 'data-uac="m.operate$$运营管理"',
        clickHandler (ev) {
          ev.preventDefault()
        },
        icon: 'crm-icon-yunyingzhongxin',
        children: [
          {
            code: 'm.operate.coupon',
            uacConfig: 'data-uac="m.operate.coupon$$运营管理.优惠券"',
            name: '优惠券',
            clickHandler (ev) {
              if (ctx.$router.currentRoute.path !== '/operate/coupon') {
                ctx.$router.push('/operate/coupon')
              }
              ev.preventDefault()
              ev.stopPropagation()
            }
          },
          {
            code: 'm.operate.feedback',
            name: '客户反馈',
            uacConfig: 'data-uac="m.operate.feedback$$运营管理.客户反馈"',
            clickHandler (ev) {
              if (ctx.$router.currentRoute.path !== '/operate/feedback') {
                ctx.$router.push('/operate/feedback')
              }
              ev.preventDefault()
              ev.stopPropagation()
            }
          }
        ]
      }, {
        code: 'm.stock',
        name: '门店库存',
        uacConfig: 'data-uac="m.stock$$门店库存"',
        icon: 'crm-icon-stock',
        clickHandler (ev) {
          if (ctx.$router.currentRoute.path !== '/stock') {
            ctx.$router.push('/stock')
          }
          ev.preventDefault()
          ev.stopPropagation()
        }
      }, {
        code: 'm.system',
        name: '权限设置',
        uacConfig: 'data-uac="m.system$$权限设置"',
        icon: 'crm-icon-system',
        clickHandler (ev) {
          if (ctx.$router.currentRoute.path !== '/system/privilege') {
            ctx.$router.push('/system/privilege')
          }
          ev.preventDefault()
          ev.stopPropagation()
        }
      }, {
        code: 'm.systemtool',
        name: '系统工具',
        uacConfig: 'data-uac="m.systemtool$$系统工具"',
        icon: 'crm-icon-tools',
        clickHandler (ev) {
          if (ctx.$router.currentRoute.path !== '/zpchelper') {
            ctx.$router.push('/zpchelper')
          }
          ev.preventDefault()
          ev.stopPropagation()
        }
      }
    ]
    if (!this.auth || !this.auth.id) {
      this.$message.error('未登录，请登录')
      this.$store.dispatch('logout')
      return
    }
    if (new Date().getTime() >= this.auth[config.expireAtProp]) {
      this.$message.error('登录信息已过期，请重新登录')
      this.$store.dispatch('logout')
      return
    }
    await this.$store.dispatch('loadStAreas')
    await this.$store.dispatch('loadShops')
    await this.$store.dispatch('loadUiPrivilege')
    await this.$store.dispatch('signalr/startSignalr')
    await this.$store.dispatch('loadSubSellers')
  },
  mounted () {
    this.$store.dispatch('signalr/attachEvtListener', this.uiPrivilegeChangeListener)
  },
  beforeDestroy () {
    this.$store.dispatch('signalr/dettachEvtListener', this.uiPrivilegeChangeListener)
  },
  methods: {
    collapseMenuOutSide (ev) {
      const eventPath = ev.path || (ev.composedPath && ev.composedPath())
      if (~eventPath.indexOf(document.querySelector('div#menu-btn'))) {
        return
      }
      if (!~eventPath.indexOf(document.querySelector('div.menu-bar'))) {
        this.collapseMenu = true
      }
    },
    handleTogglePannel () {
      this.pannelShow = !this.pannelShow
    },
    hidePannelOutSide (ev) {
      const eventPath = ev.path || (ev.composedPath && ev.composedPath())
      if (~eventPath.indexOf(document.querySelector('div.profile-info'))) {
        return
      }
      if (!~eventPath.indexOf(document.querySelector('div.ext-pannel'))) {
        this.pannelShow = false
      }
    },
    doModifyPwd () {
      this.pannelShow = false
      this.modal('PasswordModifyModal')
    },
    doTest () {
      this.collapseMenu = true
    },
    doLogout () {
      this.$store.dispatch('logout')
      this.pannelShow = false
    },
    uiPrivilegeChangeListener (message) {
      if (message && message.msgType) {
        switch (message.msgType) {
          case 'UiPrivilegeChange': {
            this.$store.dispatch('loadUiPrivilege')
            break
          }
          default: {
            console.log('received message:', message)
            break
          }
        }
      } else {
        console.log('received message:', message)
      }
    }
  }
}
</script>
